var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, IconButton, Link, ListItemIcon, ListItemText, Menu, MenuItem, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Delete02Icon, Edit02Icon, InformationCircleIcon, LinkForwardIcon, MapsIcon, MoreVerticalCircle01Icon } from 'hugeicons-react';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import { getDataGridLocaleText } from '../../../../application/common/constants/get-data-grid-locale-text';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../../application/common/helpers/grid-filter-operators';
import { useGetPaginatedClientsQuery } from '../../../../application/features/clients/client-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ProtectedElement from '../../../components/ProtectedElement';
import { Permissions } from '../../../permissions';
import ActivateClientDialog from './client-status/ActivateClient';
import DeActivateClientDialog from './client-status/DeActivateClient';
var ClientsGrid = function (_a) {
    var _b;
    var onClientClick = _a.onClientClick, onGetDirections = _a.onGetDirections, onEditClient = _a.onEditClient, onDeleteClient = _a.onDeleteClient, onShowOnMap = _a.onShowOnMap, filterClients = _a.filterClients, filterLocations = _a.filterLocations, setClientsCount = _a.setClientsCount;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var iscreen900120Landscape = useMediaQuery('(min-width:901px) and (max-width:1200px) and (orientation: landscape)');
    var _d = __read(useState(null), 2), menuRowId = _d[0], setMenuRowId = _d[1];
    var _e = __read(useState(new Set()), 2), expandedRows = _e[0], setExpandedRows = _e[1];
    var _f = __read(useState({ isOpen: false, isActive: false }), 2), clientStatusModal = _f[0], setClientStatusModal = _f[1];
    var _g = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        clients: filterClients,
        locations: filterLocations,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), paginatedClientFilters = _g[0], setPaginatedClientFilters = _g[1];
    var data = useGetPaginatedClientsQuery({
        page: paginatedClientFilters.page,
        pageSize: paginatedClientFilters.pageSize,
        sortDirection: paginatedClientFilters.sortDirection,
        sortField: paginatedClientFilters.sortField,
        filterField: paginatedClientFilters.filterField,
        filterOperator: paginatedClientFilters.filterOperator,
        filterValue: paginatedClientFilters.filterValue,
        clients: filterClients,
        locations: filterLocations
    }, { refetchOnMountOrArgChange: true }).data;
    var _h = (data !== null && data !== void 0 ? data : {}).items, paginatedClients = _h === void 0 ? [] : _h;
    var rowCountRef = useRef((_b = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _b !== void 0 ? _b : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data]);
    useEffect(function () {
        if (data && data.totalCount >= 0) {
            setClientsCount(data.totalCount);
        }
    }, [data, setClientsCount]);
    var openClientActivationModal = function (client, isActive) {
        setClientStatusModal({
            client: client,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeClientStatusModal = function () {
        setClientStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var handleToggleExpand = function (id) {
        setExpandedRows(function (prev) {
            var newExpandedRows = new Set(prev);
            if (newExpandedRows.has(id)) {
                newExpandedRows.delete(id);
            }
            else {
                newExpandedRows.add(id);
            }
            return newExpandedRows;
        });
    };
    var handleMenuClick = function (event, rowId) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(rowId);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(null);
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setPaginatedClientFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setPaginatedClientFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setPaginatedClientFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _j = __read(useState({
        items: []
    }), 2), filterModel = _j[0], setFilterModel = _j[1];
    var handlePaginationModelChange = function (model) {
        setPaginatedClientFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setPaginatedClientFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var activationModalOpen = clientStatusModal.isOpen && !clientStatusModal.isActive;
    var deActivationModalOpen = clientStatusModal.isOpen && clientStatusModal.isActive;
    var columns = __spreadArray(__spreadArray([
        {
            field: 'name',
            headerName: translate('common.client'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1.5 : 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        }
    ], __read(((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin
        ? [
            {
                field: 'companies',
                headerName: translate('common.companies'),
                flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
                minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
                sortable: false,
                filterable: false,
                disableColumnMenu: true,
                width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
                renderCell: function (params) {
                    var companies = params.value || [];
                    var displayCount = 2;
                    var isExpanded = expandedRows.has(params.row.id);
                    var companiesToShow = isExpanded ? companies : companies.slice(0, displayCount);
                    var remainingCount = companies.length - displayCount;
                    return (_jsxs(Box, { children: [companiesToShow.map(function (company) { return (_jsxs("span", { children: [company.name, " ", _jsx("br", {})] }, company.id)); }), remainingCount > 0 && !isExpanded && (_jsxs(Link, { href: '#', underline: 'always', variant: 'body2', onClick: function (e) {
                                    e.preventDefault();
                                    handleToggleExpand(params.row.id);
                                }, children: ["+", remainingCount, " ", translate('common.more')] })), isExpanded && (_jsx(Link, { href: '#', underline: 'always', variant: 'body2', onClick: function (e) {
                                    e.preventDefault();
                                    handleToggleExpand(params.row.id);
                                }, children: translate('common.showLess') }))] }));
                }
            }
        ]
        : [])), false), [
        {
            field: 'machines',
            filterable: false,
            headerName: translate('common.assets'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 150 : isMd ? 150 : isscreen600900 ? 150 : undefined
        },
        {
            field: 'contactPersonName',
            headerName: translate('clients.contactPerson'),
            sortComparator: function (v1, v2) { return v1.localeCompare(v2); },
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterable: true,
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(Typography, { variant: 'body2', color: '#161C24', children: params.row.contactPersonName }), _jsx(Typography, { variant: 'body2', color: '#454F5B', children: params.row.contactPersonPhoneNumber })] }) })); }
        },
        {
            field: 'city',
            headerName: translate('common.location'),
            filterable: true,
            sortable: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 2 : 2,
            minWidth: isXs ? 300 : isscreen600900 ? 300 : isMd ? 350 : undefined,
            width: isXs ? 300 : isMd ? 300 : isscreen600900 ? 300 : undefined,
            valueGetter: function (value, row) { return row.city || ''; },
            sortComparator: function (v1, v2) { return v1.localeCompare(v2); },
            renderCell: function (params) {
                var _a = params.row, streetName = _a.streetName, streetNumber = _a.streetNumber, postCode = _a.postCode, city = _a.city;
                var locationText = [
                    !streetNumber && !postCode ? "".concat(streetName, ",") : streetName,
                    streetNumber ? "".concat(streetNumber, ",") : null,
                    postCode ? "".concat(postCode) : null,
                    city
                ]
                    .filter(Boolean)
                    .join(' ');
                var truncatedText = locationText.length > 35 ? "".concat(locationText.substring(0, 35), "...") : locationText;
                return (_jsx(Box, { display: 'flex', marginTop: '10px', children: _jsx(Typography, { variant: 'body2', children: truncatedText }) }));
            }
        },
        {
            field: 'isActive',
            headerName: translate('common.active'),
            filterable: false,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Clients.Update], children: _jsx(Switch, { checked: params.row.isActive, onChange: function (e) { return openClientActivationModal(params.row, !e.target.checked); } }) })); }
        },
        {
            field: 'actions',
            headerName: '',
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.1 : 0.1,
            disableColumnMenu: true,
            filterable: false,
            sortable: false,
            width: isXs ? 1 : isMd ? 1 : isscreen600900 ? 1 : undefined,
            renderCell: function (params) {
                var menuItems = [
                    {
                        text: translate('clients.details'),
                        icon: InformationCircleIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            onClientClick(params.row.id);
                            handleMenuClose();
                        },
                        divider: false
                    },
                    {
                        text: translate('clients.directions'),
                        icon: LinkForwardIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            onGetDirections(params.row);
                        },
                        divider: false
                    },
                    {
                        text: translate('clients.showOnMap'),
                        icon: MapsIcon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            onShowOnMap(params.row);
                        },
                        divider: true
                    },
                    {
                        text: translate('actions.edit'),
                        icon: Edit02Icon,
                        color: theme.palette.text.primary,
                        onClick: function () {
                            handleMenuClose();
                            onEditClient(params.row.id);
                        },
                        divider: false,
                        permissions: [Permissions.Clients.Update]
                    },
                    {
                        text: translate('actions.delete'),
                        icon: Delete02Icon,
                        color: theme.palette.error.main,
                        onClick: function () {
                            handleMenuClose();
                            onDeleteClient(params.row);
                        },
                        divider: false,
                        permissions: [Permissions.Clients.Delete]
                    }
                ];
                return (_jsxs(Fragment, { children: [_jsx(IconButton, { size: 'medium', onClick: function (event) { return handleMenuClick(event, params.id); }, children: _jsx(MoreVerticalCircle01Icon, { width: 20, height: 20 }) }), _jsx(Menu, { anchorEl: anchorEl, open: menuRowId === params.id, onClose: handleMenuClose, anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center'
                            }, transformOrigin: {
                                vertical: 'top',
                                horizontal: 'center'
                            }, children: menuItems.map(function (item, index) { return (_jsx(Box, { children: item.permissions ? (_jsx(ProtectedElement, { permissions: item.permissions, children: _jsxs(MenuItem, { onClick: item.onClick, divider: item.divider, sx: { color: item.color }, children: [_jsx(ListItemIcon, { children: _jsx(item.icon, { fontSize: 20, color: item.color }) }), _jsx(ListItemText, { children: item.text })] }, item.text) })) : (_jsxs(MenuItem, { onClick: item.onClick, divider: item.divider, sx: { color: item.color }, children: [_jsx(ListItemIcon, { children: _jsx(item.icon, { fontSize: 20, color: item.color }) }), _jsx(ListItemText, { children: item.text })] }, item.text)) }, item.text)); }) })] }));
            }
        }
    ], false);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: _jsxs(Box, { sx: {
                        position: 'relative'
                    }, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            } }), _jsx(DataGrid, { localeText: getDataGridLocaleText(), sortingMode: 'server', onSortModelChange: handleSortModelChange, rows: paginatedClients, rowCount: rowCount, getRowHeight: function () { return 'auto'; }, columns: columns, disableRowSelectionOnClick: true, disableColumnSelector: true, disableColumnResize: true, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, filterDebounceMs: 500, paginationMode: 'server', pageSizeOptions: [10, 20, 50, 100], paginationModel: {
                                pageSize: paginatedClientFilters.pageSize,
                                page: paginatedClientFilters.page - 1
                            }, onPaginationModelChange: handlePaginationModelChange, slotProps: {
                                filterPanel: {
                                    filterFormProps: {
                                        operatorInputProps: {
                                            variant: 'standard'
                                        },
                                        columnInputProps: {
                                            variant: 'standard'
                                        },
                                        valueInputProps: {
                                            InputComponentProps: {
                                                variant: 'standard'
                                            }
                                        }
                                    }
                                }
                            }, sx: {
                                borderWidth: '0px',
                                backgroundColor: 'transparent',
                                overflow: 'auto',
                                outline: 'none',
                                '& .MuiDataGrid-row': {
                                    cursor: 'default',
                                    paddingTop: '8px',
                                    paddingBottom: '8px'
                                },
                                '&, [class^=MuiDataGrid]': { border: 'none' },
                                height: __assign(__assign(__assign(__assign({ xs: 'calc(100svh - 294px)', sm: 'calc(100svh - 325px)' }, (isscreen600900 && { sm: 'calc(100svh - 330px)' })), (isscreen600900Landscape && { sm: 'calc(100svh - 280px)' })), (iscreen9001200 && { sm: 'calc(100svh - 403px)' })), (iscreen900120Landscape
                                    ? { sm: 'calc(100svh - 326px)' }
                                    : iscreen9001200
                                        ? { sm: 'calc( 100svh - 357px)' }
                                        : {})),
                                '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitleContainer': {
                                    backgroundColor: '#F4F6F8 !important',
                                    border: 'none'
                                },
                                '& .MuiDataGrid-selectedRowCount': {
                                    display: 'none'
                                }
                            } })] }) }), activationModalOpen && (_jsx(ActivateClientDialog, { client: clientStatusModal.client, isOpen: activationModalOpen, onClose: closeClientStatusModal })), deActivationModalOpen && (_jsx(DeActivateClientDialog, { client: clientStatusModal.client, isOpen: deActivationModalOpen, onClose: closeClientStatusModal }))] }));
};
export default ClientsGrid;
